import { render, staticRenderFns } from "./Students.vue?vue&type=template&id=086bd02b"
import script from "./Students.vue?vue&type=script&lang=js"
export * from "./Students.vue?vue&type=script&lang=js"
import style0 from "./Students.vue?vue&type=style&index=0&id=086bd02b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports